import { BlogPost } from "ExtendiApp"
import React from "react"

import { Card, CardBody, CardImg, CardTitle } from "src/ui"

interface Props {
  postData: BlogPost
}

export const CardBlogPost: React.FC<Props> = ({ postData }) => {
  const postDate = new Date(postData.date).toLocaleDateString("en-GB")

  return (
    <Card className="blog shadow d-flex h-100">
      <CardImg top width="100%" src={postData.imageUrl} alt={postData.title} />
      <CardBody>
        <small>{postDate}</small>
        <CardTitle
          tag="h3"
          dangerouslySetInnerHTML={{ __html: postData.title || "" }}
        />
      </CardBody>
      <a
        href={postData.link}
        target="_blank"
        rel="noopener noreferrer"
        className="stretched-link"
      />
    </Card>
  )
}
